module.exports = __webpack_public_path__ + "img/SKMJ_ladder3.5c99ebd3.png";